var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { facadeApi, perFacadeApi } from 'helpers/api.helper';
import { isEnabledMockService } from 'helpers/app.helper';
import { uniqBy } from 'lodash';
import { mapEAQWithIsbnAndStudentId } from 'mocks/demo-prod/map';
import { RESOURCE_TYPES } from '../constants';
var fetchAssesAndReviewData = function (evolveUserName, hesiScoreThreshold) {
    if (evolveUserName) {
        var params = new URLSearchParams();
        params.append('hesiScoreThreshold', (hesiScoreThreshold === null || hesiScoreThreshold === void 0 ? void 0 : hesiScoreThreshold.toString()) || '');
        var actualParams = hesiScoreThreshold ? "?".concat(params) : '';
        var url = "/ps/studentprofile/assessreview/".concat(evolveUserName).concat(actualParams);
        return perFacadeApi.get(url);
    }
    return Promise.resolve({ data: {} });
};
var fetchProgramAssessAndReview = function (programId, hesiScoreThreshold) {
    var params = new URLSearchParams();
    if (programId) {
        params.append('programId', programId.toString());
        if (hesiScoreThreshold) {
            params.append('hesiScoreThreshold', hesiScoreThreshold.toString());
        }
        return perFacadeApi.get("/hesi/program/assessreview?".concat(params));
    }
    return Promise.resolve({ data: {} });
};
var fetchAllCourseAggregations = function (studentId) {
    if (studentId) {
        return perFacadeApi.get("/ps/studentprofile/allcourseaggregations/".concat(studentId));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentProfile = function (evolveUserName) {
    if (evolveUserName) {
        return perFacadeApi.get("/ps/studentprofile/".concat(evolveUserName));
    }
    return Promise.resolve({ data: {} });
};
var fetchInstructorRecentExams = function (programId) {
    if (programId) {
        return perFacadeApi.get("/hesi/recentExams/program/".concat(programId));
    }
    return Promise.resolve({ data: {} });
};
var fetchStudentProfileCards = function (evolveUsername) {
    if (evolveUsername) {
        return perFacadeApi.get("/ps/instructorprofile/assignment/".concat(evolveUsername));
    }
    return Promise.resolve({ data: {} });
};
var fetchSHCoursesCount = function (evolveUsername) {
    if (evolveUsername) {
        return perFacadeApi.get("/ps/instructorprofile/shadowcourse/".concat(evolveUsername));
    }
    return Promise.resolve({ data: { courseCount: 0 } });
};
var fetchStudentsByUserId = function (evolveUserName) {
    var params = new URLSearchParams();
    var baseUrl = '/allCourses/students';
    if (evolveUserName) {
        params.append('evolveUserName', evolveUserName.toString());
    }
    return perFacadeApi.get("".concat(baseUrl, "?").concat(params));
};
var fetchPrograms = function (evolveUsername) {
    var params = new URLSearchParams();
    var baseUrl = '/hesi/dwh/cohort/programs';
    if (evolveUsername) {
        params.append('evolveUsername', evolveUsername.toString());
    }
    return perFacadeApi.get("".concat(baseUrl, "?").concat(params));
};
var fetchStudentAssessmentMasteryByIsbnList = function (isbnIds, studentId) { return __awaiter(void 0, void 0, Promise, function () {
    var isbnList, responses, topics, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isbnList = isEnabledMockService() && mapEAQWithIsbnAndStudentId[studentId] ? mapEAQWithIsbnAndStudentId[studentId] : isbnIds;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                if (!(isbnList.length && studentId)) return [3 /*break*/, 3];
                return [4 /*yield*/, Promise.all(isbnList.map(function (isbn) { return __awaiter(void 0, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, perFacadeApi.get("/assessment/mastery/".concat(isbn, "/student/").concat(studentId))];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, { isbn: isbn, data: (response.data || []) }];
                            }
                        });
                    }); }))];
            case 2:
                responses = _a.sent();
                topics = responses.flatMap(function (_a) {
                    var isbn = _a.isbn, data = _a.data;
                    return data.map(function (topic) { return (__assign(__assign({}, topic), { bookId: isbn })); });
                });
                return [2 /*return*/, uniqBy(topics, 'assessmentTopic.chapterId')];
            case 3: return [2 /*return*/, Promise.resolve([])];
            case 4:
                e_1 = _a.sent();
                return [2 /*return*/, Promise.reject(e_1)];
            case 5: return [2 /*return*/];
        }
    });
}); };
var fetchCatalogs = function (isbnList, resourceType) {
    var params = new URLSearchParams();
    var learningTypeQuery = 'filter[learningType]';
    var baseUrl = '/sherpath/course-management/recommendation/learning/catalog/v2';
    isbnList.forEach(function (isbn) {
        params.append('filter[isbns]', isbn);
    });
    params.append('included', 'TAXONOMY');
    if (resourceType) {
        params.append(learningTypeQuery, resourceType);
    }
    else {
        Array.from(Object.keys(RESOURCE_TYPES)).forEach(function (type) {
            params.append(learningTypeQuery, type);
        });
    }
    return facadeApi.get("".concat(baseUrl, "?").concat(params));
};
var acceptTypeSheet = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export var exportStudentExamCategory = function (reqParams) {
    var params = new URLSearchParams();
    params.append('cohortId', reqParams.cohortId.toString());
    params.append('evolveUserName', reqParams.evolveUserName);
    params.append('firstName', reqParams.firstName);
    params.append('lastName', reqParams.lastName);
    return perFacadeApi.get("/hesi/dwh/cohort/export/studentExamCategoryByEvolveUsername?".concat(params), {
        responseType: 'arraybuffer',
        headers: {
            Accept: acceptTypeSheet
        }
    });
};
export var exportStudentEAQCategory = function (userId, isbnList) {
    var params = new URLSearchParams();
    isbnList.forEach(function (isbn) {
        params.append('filter[isbns]', isbn);
    });
    return perFacadeApi.get("/assessment/mastery/export/student/".concat(userId, "?").concat(params), {
        responseType: 'arraybuffer',
        headers: {
            Accept: acceptTypeSheet
        }
    });
};
export var exportStudentProfileHesiExam = function (evolveUserName) {
    var params = new URLSearchParams();
    params.append('evolveUserName', evolveUserName);
    return perFacadeApi.get("/hesi/dwh/cohort/export/studentDetailByEvolveUsername?".concat(params), {
        responseType: 'arraybuffer',
        headers: {
            Accept: acceptTypeSheet
        }
    });
};
var fetchPSDashboardDataInExcel = function (programId) {
    return perFacadeApi.get("/hesi/recentExams/export/program/".concat(programId), {
        responseType: 'arraybuffer',
        data: null,
        headers: {
            Accept: acceptTypeSheet
        }
    });
};
var fetchStudentBooks = function (userId, courseSectionId) {
    return perFacadeApi.get("/eolsUser/".concat(userId, "/courseSection/").concat(courseSectionId, "/questionSets"));
};
export { fetchAllCourseAggregations, fetchAssesAndReviewData, fetchCatalogs, fetchInstructorRecentExams, fetchProgramAssessAndReview, fetchPrograms, fetchPSDashboardDataInExcel, fetchSHCoursesCount, fetchStudentAssessmentMasteryByIsbnList, fetchStudentBooks, fetchStudentProfile, fetchStudentProfileCards, fetchStudentsByUserId };
